export default "dist/images/block-testimonial-vertical.79bf64d.png";